module.exports = __webpack_public_path__ + "static/img/space5.65905907.png";